import {Button, Space} from "antd";
import {OrderFilterOptionValueWithoutIncomplete, ServiceOrderCard} from "../card";
import {useGetStoreServicesOrdersContext} from "../../../../../service-feature/useCases/get-orders/context";
import moment from "moment";
import {StoreServiceOrderDrawer} from "../card/drawer/order-info/order-details-drawer";
import {GetStoreServicesOrdersApiResponse} from "../../../../../react-query-hooks/store/services/get-orders/types";
import {StoreServiceOrderDeliverWorkDrawer} from "../card/drawer/order-info/work-delivery/deliver-work-drawer";
import {useGetStoreServiceOrderContext} from "../../../../../service-feature/useCases/get-order/context";

export function mapStatusIdToStatus(
  statusId: number
): OrderFilterOptionValueWithoutIncomplete {
  switch (statusId) {
    // case 1: // Pending (alias for Active)
    //   return "incomplete";

    case 4: // In-Progress
      return "inprogress";

    case 3: // Completed
      return "completed";

    case 13: // Delivered
      return "delivered";

    case 15: // Dispute
      return "disputeOpened";

    case 14: // Refunded
      return "refunded";

    default:
      return "cancelled"; // safe fallback
  }
}

export function ServiceOrderListView() {
  const {
    orders,
    state: {currentPage, activeStoreServiceOrderDrawer, selectedStoreServiceOrderInfo},
    dispatch,
    isPreviousData,
    paginationMeta,
  } = useGetStoreServicesOrdersContext();

  const showOrderInfoDrawer = (order: GetStoreServicesOrdersApiResponse["orders"][0]) => {
    // storeServiceOrderDispatch({
    //   type: "set-selected-store-service-order-id",
    //   payload: order.id,
    // });
    dispatch({
      type: "set-selected-store-service-order-info",
      payload: {...order, deliveredWork: []},
    });
    dispatch({
      type: "set-active-store-service-order-drawer",
      payload: "order-info",
    });
  };

  const closeAllOrderDrawers = () => {
    // storeServiceOrderDispatch({
    //   type: "reset-state",
    // });
    dispatch({
      type: "set-active-store-service-order-drawer",
      payload: null,
    });
    dispatch({
      type: "set-selected-store-service-order-info",
      payload: null,
    });
  };
  const goToDeliverWork = () => {
    dispatch({
      type: "set-active-store-service-order-drawer",
      payload: "deliver-work",
    });
  };
  const goToOrderInfo = () => {
    dispatch({
      type: "set-active-store-service-order-drawer",
      payload: "order-info",
    });
  };
  return (
    <>
      <Space size={16} direction="vertical" style={{display: "flex"}}>
        {orders.map((o) => {
          if (o.productService) {
            return (
              <ServiceOrderCard order={o} onShowDetails={() => showOrderInfoDrawer(o)} />
            );
          } else {
            return null;
          }
        })}

        <div>
          <Space size={12}>
            <Button
              onClick={() =>
                dispatch({
                  payload: Math.max(currentPage - 1, 1),
                  type: "update-current-page",
                })
              }
              disabled={currentPage === 1}
              size="small"
            >
              Previous
            </Button>
            <Button
              onClick={() => {
                if (!isPreviousData && Number(paginationMeta?.next_page) !== 0) {
                  dispatch({
                    payload: currentPage + 1,
                    type: "update-current-page",
                  });
                }
              }}
              // Disable the Next Page button until we know a next page is available
              disabled={isPreviousData || Number(paginationMeta?.next_page) === 0}
              size="small"
            >
              Next
            </Button>
          </Space>
        </div>
      </Space>
      <StoreServiceOrderDrawer
        onOrderInfoDrawerClose={closeAllOrderDrawers}
        openOrderInfoDrawer={activeStoreServiceOrderDrawer === "order-info"}
        orderDetails={selectedStoreServiceOrderInfo}
      />
      <StoreServiceOrderDeliverWorkDrawer
        orderDetails={selectedStoreServiceOrderInfo}
        open={activeStoreServiceOrderDrawer === "deliver-work"}
        onBack={goToOrderInfo}
        onClose={closeAllOrderDrawers}
      />
    </>
  );
}
